<universal-media-chooser
	[umcInstanceName]="'response-media'"
	(onMediaDetermined)="onMediaDetermined($event.media)"
	(onEngineInit)="onRecorderInit($event.engine)"
	[options]="umcOptions"
	[ngDisabled]="isRecordEnabled()">
</universal-media-chooser>
